import _ from 'lodash'
import { Classnames as ClassnamesType } from '@wix/thunderbolt-becky-types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { Ref } from '@wix/thunderbolt-types'

type RefConsumptionDependencies = {
	dataItemWithOverrides: Array<Ref<ClassnamesType | undefined>>
}

export const Classnames = createConsumptionDataNode<null, null, RefConsumptionDependencies>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const classnames = _(dataItemWithOverrides)
			.map((override) => override?.classnames)
			.reverse()
			.flatten()
			.compact()
			.value()

		return { id, type: 'Classnames', classnames }
	},
})
